import { observer } from 'mobx-react';

import ConfigurationCodeShare from '../../../../../../configurator/components/ConfigurationShare/ConfigurationCodeShare/ConfigurationCodeShare';
import ConfigurationUrlShare from '../../../../../../configurator/components/ConfigurationShare/ConfigurationUrlShare/ConfigurationUrlShare';
import { ShareConfigurationSectionTranslation } from '../../../../../../localization/SiteTranslation';
import ModularConfiguratorSummaryState from '../ModularConfiguratorSummaryState';
import css from './ModularConfigurationShare.css';

interface ModularConfigurationShareProps {
  isLoadingConfigurationCodeError: boolean;
  isLoadingConfigurationCode: boolean;
  state: ModularConfiguratorSummaryState;
  // TODO: Extract to new interface
  translation: ShareConfigurationSectionTranslation;
  className?: string;
}

const ModularConfigurationShare = ({
  className,
  isLoadingConfigurationCodeError,
  isLoadingConfigurationCode,
  state,
  translation,
}: ModularConfigurationShareProps) => {
  return (
    <section className={className}>
      <h3 className={css.title}>{translation.title}</h3>
      {isLoadingConfigurationCodeError ? (
        <p className={css.error}>
          Something went wrong while generating your configuration code. Please try again, or contact support if the
          issue persists.
        </p>
      ) : (
        <>
          <ConfigurationCodeShare
            classNames={{ root: css.section }}
            code={state.configurationCode}
            isCodeGenerationError={false}
            isCodeLoading={isLoadingConfigurationCode}
            translation={translation.codeShare}
          />
          <ConfigurationUrlShare
            className={css.section}
            isCodeLoading={isLoadingConfigurationCode}
            translation={translation}
            url={state.shareUrl}
          />
        </>
      )}
      {/* Downloading PDF for modular configuration is not supported yet */}
      {/* <ConfigurationDownload
        className={css.section}
        filename={state.pdfName}
        downloadCommand={state.downloadAsPdfCommand}
        icon="pdf"
        label={translation.downloadAsPdf}
        disabled={state.isCodeGenerationInProgress}
      /> */}
      {/* Downloading zip for modular configuration is not supported yet */}
      {/* <ConfigurationDownload
        className={css.section}
        filename={state.zipName}
        downloadCommand={state.downloadZipCommand}
        icon="zip"
        label={translation.downloadVisualizations}
        disabled={state.isCodeGenerationInProgress}
      /> */}
    </section>
  );
};

export default observer(ModularConfigurationShare);
